import { render, staticRenderFns } from "./InActiveAccreditedCpds.vue?vue&type=template&id=4a90bec4"
import script from "./InActiveAccreditedCpds.vue?vue&type=script&lang=js"
export * from "./InActiveAccreditedCpds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports